export default function (Vue) {
  Vue.user = {
    has_permission (permissions, permission) {
      var result = false
      permissions.forEach(data => { if (data === permission) { result = true } })
      return result
    },
    can_access (roles, role) {
      var result = ''
      roles.forEach(data => { if (data === role) { result = true } else { result = false } })
      return result
    },
    getEntrepriseActuelle (entreprises, entrepriseActuelle) {
      // return true
      if (entreprises.length === 0) {
        return false
      }
      var result = entreprises.filter(ent => { return ent.id === entrepriseActuelle })[0]
      console.log(result)
      if (result.role === 0 | result.role === 1) {
        return true
      } else {
        return false
      }
    },
    getPermissionAbonnement (entreprises, entrepriseActuelle) {
      console.log(entreprises)
      // return true
      if (entreprises.length === 0) {
        return false
      }
      var result = entreprises.filter(ent => { return ent.id === entrepriseActuelle })[0]
      console.log(result)
      if (result.role === 0) {
        return true
      } else {
        return false
      }
    },
    getPermissionInvitation (entreprises, entrepriseActuelle) {
      console.log(entreprises)
      // return true
      if (entreprises.length === 0) {
        return false
      }
      var result = entreprises.filter(ent => { return ent.id === entrepriseActuelle })[0]
      console.log(result)
      if (result.role === 0) {
        return true
      } else {
        return false
      }
    }
  }
  Object.defineProperties(Vue.prototype, {
    $user: {
      get: () => {
        return Vue.user
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/packages/auth/Permission.js